import {useContext, useEffect, useRef} from 'react';

import {OrderListContext} from "../context/OrderListContext";

const LOOKUP_FILTERS = [
    {paramKey: 'lineItemStatus', type: 'LineItemStatus', multiValue: false},
    {paramKey: 'shippingMethod', type: 'ShippingMethod', multiValue: false},
    {paramKey: 'inventory', type: 'Inventory', multiValue: false},
    {paramKey: 'cancellation_reason.name[]', type: 'CancellationReason', multiValue: true},
];

const FREE_TEXT_FILTERS = [
    {paramKey: 'sellerId[]', type: 'SellerId'},
    {paramKey: 'couponCode[]', type: 'CouponCode'},
    {paramKey: 'receiptValue[]', type: 'ReceiptValue'},
];

function getRestoredFilters(queryParams, filters) {
    const params = new URLSearchParams(queryParams);
    const restored = [];
    let allResolved = true;

    LOOKUP_FILTERS.forEach(({paramKey, type, multiValue}) => {
        const ids = multiValue ? params.getAll(paramKey) : (params.get(paramKey)?.split(',').filter(Boolean) ?? []);
        const available = filters[type] ?? [];

        ids.forEach((id) => {
            const match = available.find((option) => option.id === id);

            if (match) {
                restored.push(match);
            } else {
                allResolved = false;
            }
        });
    });

    FREE_TEXT_FILTERS.forEach(({paramKey, type}) => {
        params.getAll(paramKey).forEach((value) => {
            restored.push({'@type': type, id: value, name: value});
        });
    });

    return {restored, allResolved};
}

// restores selectedFilters from the queryParams the list was mounted with
// (e.g. navigating back from an order detail), so filter chips reappear once
// their option list (fetched asynchronously by FilterOptionsSync) is ready.
// Stops touching selectedFilters once every filter id from the URL has been
// matched, so it never fights with the user's own filter changes afterward.
function FilterRestoreSync() {
    const {queryParams, filters, setSelectedFilters} = useContext(OrderListContext);

    const initialQueryParams = useRef(queryParams);
    const done = useRef(false);

    useEffect(() => {
        if (done.current) {
            return;
        }

        const {restored, allResolved} = getRestoredFilters(initialQueryParams.current, filters);

        if (restored.length > 0) {
            setSelectedFilters(restored);
        }

        if (allResolved) {
            done.current = true;
        }
    }, [filters, setSelectedFilters]);

    return null;
}

export default FilterRestoreSync;
